import React from "react";

const Header = () => {
	return (
		<div className="p-8 items-start flex flex-col min-w-content justify-center">
			<p className="text-primary-800 text-4xl w-[22rem] font-bold my-3">
				Chester Hansen
			</p>
			<p>
				A Skilled Fullstack Developer building fluid Web Applications.
			</p>
		</div>
	);
};

export default Header;
